// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { updateAccount, setForm } from '../../actions';
import Form from '../../ui/components/Forms/Account';

import { DELETE_ACCOUNT_FORM, EXPORT_DATA_FORM } from '../../constants/forms';

type Props = {
    auth: {
        language: string,
    },
    form: string,
    branding: Object,
    isDataExported: boolean,
    updateAccount: Function,
    setForm: Function,
    params: Object,
};

type State = {
    content: boolean,
    active: boolean,
    name: string,
};

export class Account extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            content: false,
            name: '',
            active: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    setDeleteForm = () => {
        this.props.setForm(DELETE_ACCOUNT_FORM);
    };

    setExportDataForm = () => {
        this.props.setForm(EXPORT_DATA_FORM);
    };

    handleContentClick = () => {
        this.setState({ content: !this.state.content });
    };

    updateAccount = (data: Object) => {
        const registerFieldsData = {};
        data.registerFields.forEach(field => {
            if (data[field.name] !== '')
                registerFieldsData[field.name] = data[field.name];
        });
        this.props.updateAccount(data.fullname, registerFieldsData);
    };

    handleFocus = e => {
        e.preventDefault();
        this.setState({
            name: e.target.name,
            active: !this.state.active,
        });
    };

    render() {
        const { auth, form, params, branding } = this.props;

        return (
            <Fragment>
                <Form
                    content={this.state.content}
                    auth={auth}
                    lng={auth.language}
                    branding={branding}
                    form={form} //enables form re-rendering
                    onSubmit={this.updateAccount}
                    deleteAccount={this.setDeleteForm}
                    exportData={this.setExportDataForm}
                    exportSuccess={this.props.isDataExported}
                    params={params}
                    handleFocus={this.handleFocus}
                    active={this.state.active}
                    name={this.state.name}
                    setForm={this.props.setForm}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        auth: state.auth,
        form: state.modal.form,
        branding: state.branding,
        params: state.form.MY_ACCOUNT_FORM,
        isDataExported: state.auth.isDataExported,
    };
};

export default connect(
    mapStateToProps,
    {
        setForm,
        updateAccount,
    }
)(Account);



// WEBPACK FOOTER //
// ./src/containers/Forms/Account.js